var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout"
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('div', {
    staticClass: "s-container"
  }, [_c('div', {
    staticClass: "content",
    style: _vm.colors
  }, [_c('div', {
    staticClass: "custom-elanco-header"
  }, [_c('span', {
    staticClass: "custom-elanco-header__text"
  }, [_vm._v("Hi " + _vm._s(_vm.deepGet(_vm.user, 'name')))]), _c('a', {
    attrs: {
      "href": _vm.deepGet(_vm.event, 'config.header_logo_url', '#')
    }
  }, [_vm.deepGet(_vm.event, 'config.images.header_logo') ? _c('img', {
    staticClass: "custom-elanco-header__image ml-3",
    attrs: {
      "src": _vm.deepGet(_vm.event, 'config.images.header_logo')
    }
  }) : _vm._e()])]), _c('div', [_vm.deepGet(_vm.event, 'config.images.mgm_kv') ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.deepGet(_vm.event, 'config.images.mgm_kv'),
      "alt": "Elanco"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "py-3 px-4"
  }, [_c('div', {
    staticClass: "text-center pt-3 content__success__title",
    domProps: {
      "innerHTML": _vm._s(_vm.successMessageTitle)
    }
  }), _c('div', {
    staticClass: "text-center pb-3 content__success__message",
    domProps: {
      "innerHTML": _vm._s(_vm.successMessage)
    }
  }), _vm.canInviteFriends ? [_c('button', {
    staticClass: "s-btn s-btn-primary s-btn-xs mb-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleShareButtonIsClicked
    }
  }, [_vm._v(" 一鍵分享邀請連結 ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs mb-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToMgmIntro
    }
  }, [_vm._v(" 揪友賺點 獎勵說明 ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs mb-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToPointsProgress
    }
  }, [_vm._v(" 開始掃描集點 ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToCouponList
    }
  }, [_vm._v(" 查看回饋詳情 ")])] : [_c('button', {
    staticClass: "s-btn s-btn-primary s-btn-xs mb-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToPointsProgress
    }
  }, [_vm._v(" 開始掃描集點 ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs mb-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToMgmIntro
    }
  }, [_vm._v(" 揪友賺點 獎勵說明 ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs mb-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToElancoIntro
    }
  }, [_vm._v(" 查看集點活動完整辦法 ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToCouponList
    }
  }, [_vm._v(" 查看回饋詳情 ")])]], 2)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }